<template>
    <section>
        <v-btn text class="px-0 green--text back" @click="$router.go(-1)" absolute v-if="$vuetify.breakpoint.mdAndDown">
            <svg v-svg="'icon-back'" size="11" fill="currentColor" class="mr-1"></svg>
            <span>{{$t('global.back')}}</span>
        </v-btn>

        <h1 class="mt-5 mb-3 text-center">{{$t('lessons.header')}}</h1>

        <v-data-table :headers="headers"
                      :items="lessonsFiltered"
                      hide-default-footer
                      class="elevation-1 mt-13 mb-6"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.id="props">
                {{props.index+1}}
            </template>

            <template v-slot:item.actions="props">
                <v-btn text class="px-0 mr-2" @click="[$refs.show.dialog = true, selectedLesson = props.item.id]">
                    <svg v-svg="'icon-show'" size="12" class="mr-1"></svg>
                    <span class="show">{{$t('global.show')}}</span>
                </v-btn>

                <v-btn text class="px-0 mx-1" @click="[$refs.attach.dialog = true, selectedLesson = props.item.id, selectedAttach = props.item.path.length]" v-if="hasRole('teacher')">
                    <svg v-svg="'icon-attach'" size="12" class="mr-1"></svg>
                    <span class="attach" v-if="props.item.path.length">{{$t('attach.attached')}}</span>
                    <span class="attach" v-else>{{$t('attach.attach')}}</span>
                </v-btn>

                <v-btn text class="px-0 ml-2"
                       :class="!props.item.path.length ? 'cursor-default' : ''"
                       :href="props.item.path" target="_blank"
                       @click="checkError(props.item.path)"
                >
                    <svg v-svg="'icon-download'" size="12" class="mr-1"></svg>
                    <span class="download">{{$t('global.download')}}</span>
                </v-btn>
            </template>

            <template v-slot:header.actions class="d-none"></template>
        </v-data-table>

        <show ref="show" :lesson_id="selectedLesson"></show>
        <attach ref="attach" :lesson_id="selectedLesson" :is_attached="selectedAttach"></attach>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Show from '@/components/Lessons/Show';
    import Attach from '@/components/Lessons/Attach';
    export default {
        components: {
            Show,
            Attach,
        },

        data(){
            return {
                loadingRequest: false,
                selectedLesson: null,
                selectedAttach: Boolean,
                subject_id: this.$route.query.subject_id || 0,
                headers: [
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: this.$t('lessons.title'), sortable: false, value: 'title'},
                    {text: 'Actions', sortable: false, value: 'actions', align: 'right'}
                ],
            }
        },

        computed: {
            ...mapGetters(['LESSONS']),
            lessonsFiltered: function () {
                return this.LESSONS.filter(item => (!this.subject_id || item.course_id === this.subject_id))
            },
        },

        mounted() {
            this.getData();
            this.$on('getData', function () {
                this.getData();
            })
        },

        methods: {
            getData(){
                this.loadingRequest = true;
                this.$store.dispatch('GET_LESSONS')
                    .then(() => this.loadingRequest = false);
            },

            checkError(path){
                if(!path.length){
                    this.$store.dispatch('alert', {type: 2, message: this.$t('attach.no_attachment')});
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/pages/tablePages";
    @import "../../scss/pages/Lessons/index";
</style>